import { render } from "./EventCard.vue?vue&type=template&id=88363720&ts=true"
import script from "./EventCard.vue?vue&type=script&lang=ts"
export * from "./EventCard.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/tik/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__